import { render } from "./RegisterLayout.vue?vue&type=template&id=98b42d7a&scoped=true"
import script from "./RegisterLayout.vue?vue&type=script&lang=js"
export * from "./RegisterLayout.vue?vue&type=script&lang=js"

import "./RegisterLayout.vue?vue&type=style&index=0&id=98b42d7a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98b42d7a"]])

export default __exports__